import { FormField, Select } from '../../../components/ui/Form';
import { DECLARATION_TYPES, DECLARATION_CATEGORIES, DECLARATION_STATUS_LABELS } from '../../../types/declarations';

export interface DeclarationFiltersState {
  type: string;
  category: string;
  period: string;
  status: string;
}

interface DeclarationFiltersProps {
  filters: DeclarationFiltersState;
  onFiltersChange: (filters: DeclarationFiltersState) => void;
}

export function DeclarationFilters({ filters, onFiltersChange }: DeclarationFiltersProps) {
  const handleFilterChange = (field: keyof DeclarationFiltersState, value: string) => {
    onFiltersChange({
      ...filters,
      [field]: value
    });
  };

  // Group declaration types by category for filter options
  const declarationTypeOptions = [
    { value: 'all', label: 'Tous les types', disabled: false },
    ...Object.entries(DECLARATION_CATEGORIES).map(([categoryKey, categoryLabel]) => ({
      value: `category:${categoryKey}`,
      label: `--- ${categoryLabel} ---`,
      disabled: true
    })),
    ...Object.entries(DECLARATION_TYPES).map(([key, value]) => ({
      value: key,
      label: `  ${value.label}`,
      disabled: false
    }))
  ];

  const statusOptions = [
    { value: 'all', label: 'Tous les statuts' },
    ...Object.entries(DECLARATION_STATUS_LABELS).map(([key, label]) => ({
      value: key,
      label
    }))
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <FormField label="Type de déclaration">
        <Select 
          value={filters.type}
          onChange={(e) => handleFilterChange('type', e.target.value)}
        >
          {declarationTypeOptions.map(option => (
            <option 
              key={option.value} 
              value={option.value}
              disabled={option.disabled}
              style={option.disabled ? { fontWeight: 'bold', color: '#666' } : {}}
            >
              {option.label}
            </option>
          ))}
        </Select>
      </FormField>

      <FormField label="Catégorie">
        <Select
          value={filters.category}
          onChange={(e) => handleFilterChange('category', e.target.value)}
        >
          <option value="all">Toutes les catégories</option>
          {Object.entries(DECLARATION_CATEGORIES).map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </Select>
      </FormField>

      <FormField label="Période">
        <Select
          value={filters.period}
          onChange={(e) => handleFilterChange('period', e.target.value)}
        >
          <option value="all">Toutes les périodes</option>
          <option value="current_month">Mois en cours</option>
          <option value="current_quarter">Trimestre en cours</option>
          <option value="current_year">Année en cours</option>
          <option value="last_month">Mois précédent</option>
          <option value="last_quarter">Trimestre précédent</option>
          <option value="last_year">Année précédente</option>
        </Select>
      </FormField>

      <FormField label="Statut">
        <Select
          value={filters.status}
          onChange={(e) => handleFilterChange('status', e.target.value)}
        >
          {statusOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      </FormField>
    </div>
  );
}